import { ApiClient, ApiError, ApiErrorCode } from '@bustickus/api';
import { AuthService } from 'common/services';
import { createApiAddress } from 'common/helpers';
import { IUserProfileFull } from 'common/entities';

class ApiProfile {
  private readonly client: ApiClient = ApiClient.getInstance();
  private static instance: ApiProfile | null = null;

  private constructor() {}

  static getInstance(): ApiProfile {
    this.instance ??= new ApiProfile();
    return this.instance;
  }

  get(): Promise<IUserProfileFull> {
    const jwt = this.jwt();
    const address = createApiAddress(`/client/profile`);
    return this.client.sendRequest<IUserProfileFull>('get', address, null, jwt);
  }

  private jwt() {
    const authService = AuthService.getInstance();
    const jwt = authService.get();

    if (jwt == null) {
      throw new ApiError(ApiErrorCode.Unauthorized);
    }

    return jwt;
  }
}

export default ApiProfile;
